(function () {
  angular
    .module('kareo.ui.shared.directives.k-edit-patient.private.billing-profile-types', [])
    .constant('BILLING_PROFILE_TYPES', Object.freeze({
      SELF_PAY: 'SELF_PAY'
    }));
})();
